import { render, staticRenderFns } from "./ReceiveForm-V2.vue?vue&type=template&id=5e78c912&scoped=true"
import script from "./ReceiveForm-V2.vue?vue&type=script&lang=js"
export * from "./ReceiveForm-V2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e78c912",
  null
  
)

export default component.exports